import React from 'react';
import { useTranslation } from '../useTranslation';
import { jsx as ___EmotionJSX } from "@emotion/react";
const HARDCODED_TITLES = ['hint', 'solution', 'incorrect'];
const Title = _ref => {
  let {
    title
  } = _ref;
  const {
    t
  } = useTranslation();
  return ___EmotionJSX("h4", {
    className: "dc-sct-feedback__title"
  }, HARDCODED_TITLES.includes(title.toLowerCase()) ? t("FeedbacksTitle.".concat(title.toLowerCase())) : title);
};
export default Title;